'use client';

import Link from 'next/link';
import { PlusCircle } from 'lucide-react';
import { v4 as uuidv4 } from 'uuid';
import { useRouter } from 'next/navigation';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

function CreativeGroup({ title, items }) {
  return (
    <div className="mb-8">
      <h2 className="text-xl font-semibold mb-4 text-muted-foreground">
        {title}
      </h2>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {items.map((item) => (
          <Link href={item.href} key={item.id}>
            <Card className="w-full cursor-pointer transition-all duration-200 hover:shadow-md hover:scale-[1.02]">
              <CardHeader>
                <CardTitle>{item.title}</CardTitle>
                <CardDescription>{item.description}</CardDescription>
                <p className="text-sm text-muted-foreground mt-2">
                  {item.date}
                </p>
              </CardHeader>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default function DCOCreativeList() {
  const router = useRouter();

  const creatives = {
    videoStudio: [
      {
        id: 2,
        href: '/video/studio/715d1232-f984-42a2-8819-91a7d5615a66',
        title: 'DCO Creative 1',
        description: 'Video Creative',
        date: '2025-04-07',
      },
    ],
    aeWizard: [
      {
        id: 4,
        href: '/video/ae-wizard/18bc3736-6e27-4f8f-9a75-faed06d01070',
        title: 'DCO Creative 2',
        description: 'AE Wizard with Video & Layers',
        date: '2025-04-07',
      },
    ],
    digitalStudio: [
      {
        id: 5,
        href: '/digital/studio/9a863582-67e0-4778-88f6-5256db46c57a',
        title: 'DCO Creative 3',
        description: 'Digital Studio',
        date: '2025-04-07',
      },
    ],
  };

  return (
    <div className="container mx-auto p-4 h-full">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Example DCO Creatives</h1>
        <Button
          onClick={() => {
            router.push(`/creatives/${uuidv4()}`);
          }}
        >
          <PlusCircle className="mr-2 h-4 w-4" /> Create New
        </Button>
      </div>

      <CreativeGroup title="Video Studio" items={creatives.videoStudio} />
      <CreativeGroup title="Video AE Wizard" items={creatives.aeWizard} />
      <CreativeGroup title="Digital Studio" items={creatives.digitalStudio} />
    </div>
  );
}
